import { Group, Item, ModelDTO, ModelGroupDTO } from '../../ManageExcessCashModal.meta';

interface UsePortfolioGroupParams {
  portfolioGroup: ModelGroupDTO[];
}

const getPortfolioItemOptions = (portfolioItem: ModelDTO) => {
  return {
    label: portfolioItem.portfolioName,
    value: portfolioItem.id,
  };
};

const getPortfolioGroupOptions = (portfolioGroup: ModelGroupDTO) => {
  return {
    label: portfolioGroup.groupName,
    options: portfolioGroup.modelPortfolios.map(getPortfolioItemOptions),
  };
};

export const usePortfolioGroup = ({ portfolioGroup }: UsePortfolioGroupParams) => {
  const modelPortfolios = portfolioGroup.map(getPortfolioGroupOptions);
  return { modelPortfolios };
};
